import React, { createContext } from 'react'
import taxTypes from '../configurations/tax-types'
import nonTaxableTaxTypes from '../configurations/non-taxable-tax-types'
import { calculateDecimal } from '../utils/helpers'
import { useDebouncedCallback } from 'use-debounce'

const InvoiceItemsContext = createContext({})

const InvoiceItemsProvider = ({ listArr, formActions, currencies, children }) => {
  let allTaxes = [...taxTypes, ...nonTaxableTaxTypes]
  let allWithdrawTaxes = allTaxes?.filter(item => !!item?.withdraw)?.map(item => item.key)

  const [updateParentTemp, setUpdateParentTemp] = React.useState(null)
  const [isDialogOpen, setIsDialogOpen] = React.useState(false)
  const [isDialogView, setIsDialogView] = React.useState(false)
  React.useEffect(() => {
      setListingPage(0)
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  const [sameCurrency, setSameCurrency] = React.useState(true)
  const [currentCurrency, setCurrentCurrency] = React.useState({
    id: 0,
    key: 'EGP',
    name_en: 'Egyptian Pound',
    name_ar: 'جنيه مصري',
    rate: 1
  })
  const [listingRowsPerPage, setListingRowsPerPage] = React.useState(10)
  const [listingLoading, setListingLoading] = React.useState(false)
  const [allListingData, setAllListingData] = React.useState(!!listArr ? [...listArr] : [])
  const [listingData, setListingData] = React.useState([])
  const [currentSelectedRow, setCurrentSelectedRow] = React.useState({})
  const [currentDialogAction, setCurrentDialogAction] = React.useState('')
  const [listingPage, setListingPage] = React.useState(-1)
  const [listingCount, setListingCount] = React.useState(listArr?.length || 0)
  const [deleteItemLoading, setDeleteItemLoading] = React.useState(false)

  React.useEffect(() => {
      if (listingPage > -1) {
        getListingData()
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [listingPage, listingRowsPerPage])


  // React.useEffect(() => {
  //     console.log('isDialogOpen', isDialogOpen)
  //   }, // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [isDialogOpen])

  // const [totalSalesAmountEdit, setTotalSalesAmountEdit] = React.useState(formActions.values.totalSalesAmountEdit)
  const [totalDiscountAmountEdit, setTotalDiscountAmountEdit] = React.useState(formActions.values.totalDiscountAmountEdit)
  const [netAmountEdit, setNetAmountEdit] = React.useState(formActions.values.netAmountEdit)
  // const [totalItemsDiscountAmountEdit, setTotalItemsDiscountAmountEdit] = React.useState(formActions.values.totalItemsDiscountAmountEdit)
  const [totalAmountEdit, setTotalAmountEdit] = React.useState(formActions.values.totalAmountEdit)


  // const [invoiceLines, setInvoiceLines] = React.useState(formActions.values.invoiceLines)
  // const [totalSalesAmount, setTotalSalesAmount] = React.useState(formActions.values.totalSalesAmount)
  const [totalDiscountAmount, setTotalDiscountAmount] = React.useState(formActions.values.totalDiscountAmount)
  // const [totalItemsDiscountAmount, setTotalItemsDiscountAmount] = React.useState(formActions.values.totalItemsDiscountAmount)
  const [netAmount, setNetAmount] = React.useState(formActions.values.netAmount)
  const [extraDiscountAmount, setExtraDiscountAmount] = React.useState(formActions.values.totalTaxableItems)


  React.useEffect(() => {
      calculateLinesValues(allListingData)
      setTimeout(() => {
        getListingData(updateParentTemp)
        formActions.validateForm()
      }, 100)
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [allListingData])

  React.useEffect(() => {
      calculateLinesValues(allListingData)
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [netAmount, totalDiscountAmount, extraDiscountAmount])

  const handleSwitchEditChange = (value, setValue, fieldName, isTax) => {
    if (!!isTax) {
      setValue(value, fieldName)
    } else {
      setValue(value)
    }
    if (!!fieldName) {
      switch (fieldName) {
        // case 'totalSalesAmount':
        //   if (!value) {
        //     formActions.setFieldValue('totalSalesAmount', formActions.values.calculatedTotalSalesAmount)
        //   }
        //   formActions.setFieldValue('totalSalesAmountEdit', !!value || false)
        //   break
        case 'netAmount':
          if (!value) {
            formActions.setFieldValue('netAmount', !!sameCurrency ? formActions.values.calculatedNetAmount : formActions.values.calculatedNetAmountEGP)
            setNetAmount(!!sameCurrency ? formActions.values.calculatedNetAmount : formActions.values.calculatedNetAmountEGP)
          }
          formActions.setFieldValue('netAmountEdit', !!value || false)
          break
        // case 'totalItemsDiscountAmount':
        //   if (!value) {
        //     formActions.setFieldValue('totalItemsDiscountAmount', !!sameCurrency ? formActions.values.calculatedTotalItemsDiscountAmount : formActions.values.calculatedTotalItemsDiscountAmountEGP)
        //   }
        //   formActions.setFieldValue('totalItemsDiscountAmountEdit', !!value || false)
        //   break
        case 'totalDiscountAmount':
          if (!value) {
            formActions.setFieldValue('totalDiscountAmount', !!sameCurrency ? formActions.values.calculatedTotalDiscountAmount : formActions.values.calculatedTotalDiscountAmountEGP)
            setTotalDiscountAmount(!!sameCurrency ? formActions.values.calculatedTotalDiscountAmount : formActions.values.calculatedTotalDiscountAmountEGP)
          }
          formActions.setFieldValue('totalDiscountAmountEdit', !!value || false)
          break
        case 'totalAmount':
          if (!value) {
            formActions.setFieldValue('totalAmount', !!sameCurrency ? formActions.values.calculatedTotalAmount : formActions.values.calculatedTotalAmountEGP)
          }
          formActions.setFieldValue('totalAmountEdit', !!value || false)
          break
        default:
          break

      }
    }
  }

  const setTaxEdit = (value, taxType) => {
    let taxes = formActions.values.taxTotals
    let valueIndex = taxes?.map(oldTax => oldTax.taxType)?.indexOf(taxType)
    if (valueIndex > -1) {
      taxes[valueIndex]['amountEdit'] = value
      if (!value) {
        taxes[valueIndex]['amount'] = taxes[valueIndex]['calculatedAmount']
      }
    }
    formActions.setFieldValue('taxTotals', taxes || [])
  }

  const calculateLinesValues = (ItemsList) => {
    if (!!ItemsList?.length) {
      let totalTaxes = 0
      let totalTaxesEGP = 0

      let calculatedTotalSalesAmount = 0
      let calculatedTotalSalesAmountEGP = 0

      let calculatedTotalDiscountAmount = 0
      let calculatedTotalDiscountAmountEGP = 0

      let calculatedNetAmount = 0
      let calculatedNetAmountEGP = 0

      // let calculatedValueDifference = 0
      // let calculatedValueDifferenceEGP = 0

      let calculatedDiscountAmount = 0
      let calculatedDiscountAmountEGP = 0

      let currency = ItemsList?.map(item => item?.amountSold)
      let sameCurrencyFlag = new Set(currency).size === 1
      setSameCurrency(sameCurrencyFlag)
      let currencyObj = !!sameCurrencyFlag ? currencies?.filter(currencyItem => currencyItem?.key === currency[0]) : []
      setCurrentCurrency(currencyObj?.length ? currencyObj[0] : currencies[0])

      // let allNoFeesTaxes = allTaxes?.filter(item => !!item?.noFees)?.map(item => item.key)
      let allItemsTaxes = ItemsList?.filter(item => !item?.deleted)?.map(item => item?.taxableItems?.map(taxItem => ({
        ...taxItem,
        valueEGP: calculateDecimal(parseFloat(taxItem.value) * (parseFloat(item?.currencyRate?.rate) || 1))
      })))?.reduce((a, b) => !!b ? a.concat(b) : a, [])?.reduce(function(r, a) {
        r[a.type] = r[a.type] || []
        r[a.type].push(a)
        return r
      }, Object.create(null))

      let calculatedTaxes = Object.keys(allItemsTaxes || {})?.map(item => {
        let valueBefore = formActions.values.taxTotals?.filter(oldTax => oldTax.taxType === item)
        let taxObj = valueBefore?.length ? { ...valueBefore[0], calculatedAmount: 0, calculatedAmountEGP: 0 } : {
          taxType: item,
          amount: 0,
          amountEdit: false,
          calculatedAmount: 0,
          calculatedAmountEGP: 0
        }
        allItemsTaxes[item]?.forEach(tax => {
          taxObj.calculatedAmount += parseFloat(tax.value) || 0
          taxObj.calculatedAmountEGP += parseFloat(tax.valueEGP) || 0
        })
        taxObj.calculatedAmount = calculateDecimal(taxObj.calculatedAmount)
        taxObj.calculatedAmountEGP = calculateDecimal(taxObj.calculatedAmountEGP)
        if (!taxObj?.amountEdit) {
          taxObj.amount = !!sameCurrencyFlag ? taxObj.calculatedAmount : taxObj.calculatedAmountEGP
        }

        // if (!allNoFeesTaxes.includes(item)) {
        //   calculatedTaxFees += parseFloat(taxObj.amount) || 0
        // }

        if (!!allWithdrawTaxes.includes(item)) {
          totalTaxes -= parseFloat(taxObj.amount) || 0
          totalTaxesEGP -= !!sameCurrencyFlag ? (parseFloat(taxObj.amount) || 0) * ((parseFloat(taxObj.calculatedAmountEGP) / parseFloat(taxObj.calculatedAmount)) || 0) : parseFloat(taxObj.calculatedAmountEGP)
        } else {
          totalTaxes += parseFloat(taxObj.amount) || 0
          totalTaxesEGP += !!sameCurrencyFlag ? (parseFloat(taxObj.amount) || 0) * ((parseFloat(taxObj.calculatedAmountEGP) / parseFloat(taxObj.calculatedAmount)) || 0) : parseFloat(taxObj.calculatedAmountEGP)
        }
        return taxObj
      }) || []

      formActions.setFieldValue('taxTotals', calculatedTaxes || [])
      formActions.setFieldValue('invoiceLines', ItemsList || [])

      ItemsList.filter(item => !item?.deleted)?.forEach((item) => {
        calculatedTotalSalesAmount += parseFloat(item.salesTotal) || 0
        calculatedTotalSalesAmountEGP += ((parseFloat(item.salesTotal) || 0) * (parseFloat(item?.currencyRate?.rate) || 1))

        calculatedTotalDiscountAmount += parseFloat(item.discountValue) || 0
        calculatedTotalDiscountAmountEGP += ((parseFloat(item.discountValue) || 0) * (parseFloat(item?.currencyRate?.rate) || 1))

        calculatedNetAmount += parseFloat(item.netTotal) || 0
        calculatedNetAmountEGP += ((parseFloat(item.netTotal) || 0) * (parseFloat(item?.currencyRate?.rate) || 1))

        // calculatedValueDifference += parseFloat(item.valueDifference) || 0
        // calculatedValueDifferenceEGP += ((parseFloat(item.valueDifference) || 0) * (parseFloat(item?.currencyRate?.rate) || 1))

        calculatedDiscountAmount += (parseFloat(item.itemsDiscount) || 0)
        calculatedDiscountAmountEGP += ((parseFloat(item.itemsDiscount) || 0) * (parseFloat(item?.currencyRate?.rate) || 1))
      })

      let discountAmountForTotal = (!!totalDiscountAmountEdit) ? parseFloat(formActions.values.totalDiscountAmount || 0) : calculatedTotalDiscountAmount
      let total = calculateDecimal(totalTaxes + calculatedTotalSalesAmount - (calculatedDiscountAmount + discountAmountForTotal + (parseFloat(extraDiscountAmount) || 0)))

      let discountAmountForTotalEGP = (!!totalDiscountAmountEdit) ? parseFloat(formActions.values.totalDiscountAmount || 0) : calculatedTotalDiscountAmountEGP
      let totalEGP = calculateDecimal(totalTaxesEGP + calculatedTotalSalesAmountEGP - (calculatedDiscountAmountEGP + discountAmountForTotalEGP + (parseFloat(extraDiscountAmount) || 0)))

// console.log(!!totalAmountEdit? formActions.values.totalAmount : (!!sameCurrencyFlag ? total : totalEGP))
      formActions.setValues({
        'taxTotals': calculatedTaxes || [],
        'invoiceLines': ItemsList || [],
        'extraDiscountAmount': formActions.values.extraDiscountAmount,

        'calculatedTotalSalesAmount': calculateDecimal(calculatedTotalSalesAmount),
        'calculatedTotalSalesAmountEGP': calculateDecimal(calculatedTotalSalesAmountEGP),
        'totalSalesAmount': calculateDecimal(!!sameCurrencyFlag ? calculatedTotalSalesAmount : calculatedTotalSalesAmountEGP),
        'totalSalesAmountEdit': formActions.values.totalSalesAmountEdit,

        'calculatedTotalDiscountAmount': calculateDecimal(calculatedTotalDiscountAmount),
        'calculatedTotalDiscountAmountEGP': calculateDecimal(calculatedTotalDiscountAmountEGP),
        'totalDiscountAmount': !!totalDiscountAmountEdit ? formActions.values.totalDiscountAmount : calculateDecimal(!!sameCurrencyFlag ? calculatedTotalDiscountAmount : calculatedTotalDiscountAmountEGP),
        'totalDiscountAmountEdit': formActions.values.totalDiscountAmountEdit,

        'calculatedNetAmount': calculateDecimal(calculatedNetAmount),
        'calculatedNetAmountEGP': calculateDecimal(calculatedNetAmountEGP),
        'netAmount': !!netAmountEdit ? formActions.values.netAmount : calculateDecimal(!!sameCurrencyFlag ? calculatedNetAmount : calculatedNetAmountEGP),
        'netAmountEdit': formActions.values.netAmountEdit,

        'calculatedTotalItemsDiscountAmount': calculateDecimal(calculatedDiscountAmount),
        'calculatedTotalItemsDiscountAmountEGP': calculateDecimal(calculatedDiscountAmountEGP),
        'totalItemsDiscountAmount': calculateDecimal(!!sameCurrencyFlag ? calculatedDiscountAmount : calculatedDiscountAmountEGP),
        'totalItemsDiscountAmountEdit': formActions.values.totalItemsDiscountAmountEdit,

        'calculatedTotalAmount': total,
        'calculatedTotalAmountEGP': totalEGP,
        'totalAmount': !!totalAmountEdit ? formActions.values.totalAmount : (!!sameCurrencyFlag ? total : totalEGP),
        'totalAmountEdit': formActions.values.totalAmountEdit

      })

      // formActions.setFieldValue('calculatedTotalSalesAmount', calculateDecimal(calculatedTotalSalesAmount))
      // formActions.setFieldValue('calculatedTotalSalesAmountEGP', calculateDecimal(calculatedTotalSalesAmountEGP))
      // formActions.setFieldValue('totalSalesAmount', calculateDecimal(!!sameCurrencyFlag ? calculatedTotalSalesAmount : calculatedTotalSalesAmountEGP))
      // // if (!totalSalesAmountEdit) {
      // // }
      // // if (!totalDiscountAmountEdit) {
      // // }
      // formActions.setFieldValue('calculatedTotalDiscountAmount', calculateDecimal(calculatedTotalDiscountAmount))
      // formActions.setFieldValue('calculatedTotalDiscountAmountEGP', calculateDecimal(calculatedTotalDiscountAmountEGP))
      // formActions.setFieldValue('totalDiscountAmount', calculateDecimal(!!sameCurrencyFlag ? calculatedTotalDiscountAmount : calculatedTotalDiscountAmountEGP))
      //
      // formActions.setFieldValue('calculatedNetAmount', calculateDecimal(calculatedNetAmount))
      // formActions.setFieldValue('calculatedNetAmountEGP', calculateDecimal(calculatedNetAmountEGP))
      // if (!netAmountEdit) {
      //   formActions.setFieldValue('netAmount', calculateDecimal(!!sameCurrencyFlag ? calculatedNetAmount : calculatedNetAmountEGP))
      // }
      // formActions.setFieldValue('calculatedTotalItemsDiscountAmount', calculateDecimal(calculatedDiscountAmount))
      // formActions.setFieldValue('calculatedTotalItemsDiscountAmountEGP', calculateDecimal(calculatedDiscountAmountEGP))
      // if (!totalItemsDiscountAmountEdit) {
      //   formActions.setFieldValue('totalItemsDiscountAmount', calculateDecimal(!!sameCurrencyFlag ? calculatedDiscountAmount : calculatedDiscountAmountEGP))
      // }
      // let discountAmountForTotal = (!!totalItemsDiscountAmountEdit) ? formActions.values.totalItemsDiscountAmount : calculatedDiscountAmount
      // let total = calculateDecimal(totalTaxes + calculatedTotalSalesAmount - (calculatedTotalDiscountAmount + discountAmountForTotal + (parseFloat(extraDiscountAmount) || 0)))
      //
      // let discountAmountForTotalEGP = (!!totalItemsDiscountAmountEdit) ? formActions.values.totalItemsDiscountAmount : calculatedDiscountAmountEGP
      // let totalEGP = calculateDecimal(totalTaxesEGP + calculatedTotalSalesAmountEGP - (calculatedTotalDiscountAmountEGP + discountAmountForTotalEGP + (parseFloat(extraDiscountAmount) || 0)))
      //
      // formActions.setFieldValue('calculatedTotalAmount', total)
      // formActions.setFieldValue('calculatedTotalAmountEGP', totalEGP)
      // if (!totalAmountEdit) {
      //   formActions.setFieldValue('totalAmount', !!sameCurrencyFlag ? total : totalEGP)
      // }
    } else {
      formActions.resetForm()
    }
  }

  const debouncedChange = useDebouncedCallback((fieldName, value) => {
    setFieldCalculations(fieldName, value)
  }, 200)


  const DecimalChange = (event, fieldName) => {
    const re = /^[0-9]*\.?[0-9]*$/
    if (event.target.value === '' || re.test(event.target.value)) {
      formActions.setFieldValue(fieldName, event.target.value)
      debouncedChange(fieldName, event.target.value)
      // setFieldCalculations(fieldName, event.target.value)
    }
  }

  const DecimalBlur = (event, fieldName) => {
    let value = calculateDecimal(event.target.value)
    formActions.setFieldValue(fieldName, value)
    setFieldCalculations(fieldName, event.target.value)
  }

  const setFieldCalculations = (fieldName, fieldValue) => {
    if (!!fieldName) {
      switch (fieldName) {
        // case 'totalSalesAmount':
        //   setTotalSalesAmount(fieldValue || 0)
        //   break
        case 'netAmount':
          setNetAmount(fieldValue || 0)
          break
        // case 'totalItemsDiscountAmount':
        //   setTotalItemsDiscountAmount(fieldValue || 0)
        //   break
        case 'totalDiscountAmount':
          setTotalDiscountAmount(fieldValue || 0)
          break
        case 'extraDiscountAmount':
          setExtraDiscountAmount(fieldValue || 0)
          break
        default:
          break
      }
    }
  }


  const handleChangeListingPage = (newPage) => {
    setListingPage(newPage)
  }

  const handleChangeListingRowsPerPage = (newRows) => {
    setListingRowsPerPage(+newRows)
    setListingPage(0)
  }

  const getListingData = (updateParentEntity) => {
    setListingLoading(true)
    if (!!allListingData.length) {
      setListingCount(allListingData?.length)
      setListingData(allListingData.slice(Math.max(listingPage, 0) * listingRowsPerPage, (Math.max(listingPage, 0) + 1) * listingRowsPerPage))
    } else {
      setListingCount(0)
      setListingData([])
    }
    if (!!updateParentEntity) {
      updateParentEntity(allListingData)
      setUpdateParentTemp(null)
    }
    setTimeout(() => setListingLoading(false), 200)
  }

  const dialogActionSubmit = (values, FormikActions) => {
    setListingLoading(true)
    if (currentDialogAction === 'delete') {
      setDeleteItemLoading(true)
      let dataIndex = allListingData?.map(item => item?.id?.toString()).indexOf(currentSelectedRow?.id?.toString())
      if (dataIndex > -1) {
        setAllListingData(prevState => {
          let listingDataToDelete = [...prevState]
          listingDataToDelete.splice(dataIndex, 1)
          return listingDataToDelete
        })
      }
    } else {
      values.id = values?.id || (allListingData?.length ? allListingData[allListingData?.length - 1]?.id + 1 : 1)
      setCurrentSelectedRow({ ...currentSelectedRow, ...values } || {})
      let dataIndex = allListingData?.map(item => item?.id?.toString()).indexOf(values?.id?.toString())
      if (dataIndex > -1) {
        setAllListingData(prevState => {
          let listingDataToUpdate = [...prevState]
          listingDataToUpdate[dataIndex] = values
          return listingDataToUpdate
        })
      } else {
        setAllListingData(prevState => [...prevState, values])
      }
    }
    setTimeout(cancelDialog, 100)

    setTimeout(() => {
      setDeleteItemLoading(false)
      if (!!FormikActions) {
        FormikActions.setSubmitting(false)
      }
    }, 300)
  }


  const openDialog = (type, selectedRow, id, handleMenuClose, updateParentEntity, isVirtual, isDeleted) => {
    if (!isDialogOpen) {
      setIsDialogView(true)
    } else {
      setTimeout(() => {
        setIsDialogView(false)
      }, 500)
    }
    if (!!handleMenuClose) {
      handleMenuClose()
    }
    setCurrentSelectedRow(selectedRow || {})
    setCurrentDialogAction(type || 'create')

    if (type === 'delete') {
      deleteRecord(selectedRow, id, updateParentEntity, isVirtual, isDeleted)
    } else {
      setIsDialogOpen(!isDialogOpen)
    }
  }

  const deleteRecord = (selectedRow, id, updateParentEntity, isVirtual, isDeleted) => {
    let dataIndex = allListingData?.map(item => item?.id?.toString()).indexOf(selectedRow?.id?.toString())
    if (!!updateParentEntity) {
      setUpdateParentTemp(updateParentEntity)
    }
    if (dataIndex > -1) {
      let data = [...allListingData]
      if (!!isVirtual) {
        data[dataIndex]['deleted'] = !isDeleted
      } else {
        data.splice(dataIndex, 1)
      }
      setAllListingData(data)
    }
    // setTimeout(() => {
    //   formActions.setFieldTouched('invoiceLines', true, true)
    //   getListingData(updateParentEntity)
    // }, 300)
  }

  const cancelDialog = () => {
    setIsDialogOpen(false)
  }
  return (
    <InvoiceItemsContext.Provider value={{
      listingData,
      listingLoading,

      listingCount,
      listingRowsPerPage,
      listingPage,
      handleChangeListingPage,
      handleChangeListingRowsPerPage,

      isDialogOpen,
      isDialogView,
      openDialog,
      cancelDialog,

      currentSelectedRow,
      currentDialogAction,

      dialogActionSubmit,
      deleteItemLoading,

      sameCurrency,
      currentCurrency,


      handleSwitchEditChange,
      DecimalBlur,
      DecimalChange,
      setTaxEdit,


      // totalSalesAmountEdit,
      // setTotalSalesAmountEdit,

      totalDiscountAmountEdit,
      setTotalDiscountAmountEdit,

      netAmountEdit,
      setNetAmountEdit,

      // totalItemsDiscountAmountEdit,
      // setTotalItemsDiscountAmountEdit,

      totalAmountEdit,
      setTotalAmountEdit

    }}>
      {children}
    </InvoiceItemsContext.Provider>
  )
}
const InvoiceItemsConsumer = InvoiceItemsContext.Consumer

export { InvoiceItemsProvider, InvoiceItemsConsumer }
